var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewECmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,179.4c11.1-26.4,28.6-47.7,52.2-63.6C94.1,99.9,120.4,92,149.4,92c12.8,0,25.1,1.6,36.9,4.7 c-0.1-9.6-0.7-12.8-3-16.5c-0.8-1.3-13.1-16.3-27.4-33.5c-27.3-32.8-27.6-33.1-33.9-35.5c-2.5-0.9-4.8-1-46.5-1 c-24.3-0.1-45.2,0-46.7,0.2c-9.2,1.3-16.9,9.3-18.2,18.7C10.2,31,10,70.3,10,120.8c0,94.4,0,92.2,2.5,97.2 c2.7,5.3,7.5,9.4,12.9,11.1c2.9,0.9,4.4,1,28.5,1C38.5,216.2,26.6,199.3,18.3,179.4z M76.2,70.7V53.9h11.1h11.1v16.8v16.8H87.2H76.2 V70.7z M43.1,70.7V53.9h11.1h11.1v16.8v16.8H54.2H43.1V70.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.6,219.3c11.2,0,20.9-4,28.7-11.8c7.8-7.8,11.9-17.5,11.9-28.8s-4-20.9-11.8-28.7s-17.5-11.9-28.8-11.9 s-20.9,4-28.7,11.8c-7.9,7.9-11.9,17.5-11.9,28.8s4,20.9,11.8,28.7C129.8,215.4,139.4,219.3,150.6,219.3z M150.6,195.8 c-4.7,0-8.7-1.7-12.1-4.9s-4.9-7.4-4.9-12.1s1.7-8.7,4.9-12.1c3.2-3.4,7.4-4.9,12.1-4.9s8.7,1.7,12.1,4.9c3.4,3.2,4.9,7.4,4.9,12.1 s-1.7,8.7-4.9,12.1C159.5,194.2,155.3,195.8,150.6,195.8z M150.6,248.3c-22.9,0-43.9-6.3-62.7-19c-18.9-12.6-32.7-29.4-41.5-50.6 c8.9-21,22.7-37.9,41.5-50.6s39.7-19,62.7-19s43.9,6.3,62.7,19s32.7,29.4,41.5,50.6c-8.9,21-22.7,37.9-41.5,50.6 C194.6,242,173.5,248.3,150.6,248.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewECmr);
export default __webpack_public_path__ + "static/media/view-e-cmr.395b88e58e0b6b99c920ffe21c181129.svg";
export { ForwardRef as ReactComponent };